module.exports = __webpack_public_path__ + "img/phone-hangup.36ad5c2e.svg";